import React from 'react';
import { observer } from 'mobx-react';
import { autorun, observable } from 'mobx';
import { AppUI } from '@seedlang/state';
import ErrorBoundary from 'components/hoc/error_boundary';
import autobind from 'autobind-decorator';
import styled from '@emotion/styled';
import Checkbox from 'components/checkbox';
import Text from 'components/text';
import PageTitle from 'components/common/page_title';
import Stack, { gaps } from 'components/layout/stack';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.md};
`;

const Row = styled.div`
  display: flex;
`;

const Expand = styled.div`
  font-size: 16px;
  flex: 1;
`;

@observer
class SettingsUserNotifications extends React.Component {
  @observable userAgreedToEmail;

  constructor(props) {
    super(props);
    this.disposer = autorun(() => {
      if (AppUI.userIsLoaded && !this.userIsLoaded) {
        this.userIsLoaded = true;
        this.userAgreedToEmail = AppUI.user?.currentUserGroup?.userAgreedToEmail === 'true';
      }
    });
  }

  componentWillUnmount() {
    this.disposer && this.disposer();
  }

  @autobind onClickEmailConfirmation() {
    this.userAgreedToEmail = !this.userAgreedToEmail;
    AppUI.userGroupStore.update({ids: {userGroupId: AppUI.user.currentUserGroup?.id}, data: {user_agreed_to_email: this.userAgreedToEmail ? 'true' : 'false'}}, AppUI.loadUser);
  }

  render() {
    return (
      <Wrapper>
        <PageTitle>Email Preferences</PageTitle>
        <Text heading='2'>Email Preferences</Text>
        <Row>
          <Checkbox
            value={this.userAgreedToEmail}
            onClick={this.onClickEmailConfirmation}
            margin='5px 10px 0 0'
            width='20px'
            height='20px'
          />
          <Expand>
            {`I want to receive emails from ${AppUI.site.name || 'us'} about new content, membership updates, and marketing offers for related products. I can unsubscribe anytime.`}
          </Expand>
        </Row>
        <Stack gap='xs'>
          <Text heading='5'>🚧 More Email Preferences Soon</Text>
          <small>You will soon have the ability to specific which types of content notifications and emails to receive. Until then, we recommend leaving all emails enabled.</small>
        </Stack>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(SettingsUserNotifications);
